import { Button } from 'src/components/Button/Button'
import { GiftSubscriptionClaimButton } from 'src/components/GiftSubscription/GiftSubscriptionClaimButton'
import { Headline } from 'src/components/Headline/Headline'
import { Text } from 'src/components/Text/Text'

import styles from './TopInfoSection.module.scss'

interface TopInfoSectionProps {
  subtitle: string
  isBuyPage?: boolean
}

export const TopInfoSection = ({ subtitle, isBuyPage }: TopInfoSectionProps) => {
  const primaryButtonText = isBuyPage ? 'Geschenkabo einrichten' : 'Jetzt dein Geschenkabo einlösen'
  const rightSideHeadline = isBuyPage ? 'Deine Vorteile beim Geschenkabo' : 'So funktioniert’s'

  const buyListItems = [
    'Verschenke eine neue Kaffeeerfahrung – mit aufregenden, frisch gerösteten Kaffees bester Qualität.',
    'Geschenkkarte personalisieren und per E-Mail verschicken und optional zum Überreichen ausdrucken.',
    'Abo einmalig abschließen, wir kümmern uns um den Rest.',
    'Kostenloser und klimaneutraler Versand inklusive.',
  ]

  const claimPageListItems = [
    'Melde dich mit deiner E-Mail Adresse an, mit der du die Versandbenachrichtigungen erhalten möchtest.',
    'Teile uns im nächsten Schritt deine Adresse für die Lieferungen mit.',
    'Deine erste Lieferung wird sofort für den Versand vorbereitet.',
    'Danach erhältst du automatisch alle vier Wochen eine weitere Lieferung, entsprechend der Anzahl an Lieferungen deines Gutscheines.',
  ]

  const listItems = isBuyPage ? buyListItems : claimPageListItems

  return (
    <section className={styles.container}>
      <div className={styles.left}>
        <Text variant="intro" className={styles.introOverride}>
          {subtitle}
        </Text>
        <div className={styles.buttonsWrapper}>
          {isBuyPage ? (
            <Button variant="primary" fullWidthMobile href="#gift-subscription-configure">
              {primaryButtonText}
            </Button>
          ) : (
            <GiftSubscriptionClaimButton />
          )}
          {isBuyPage && (
            <Button variant="secondary" fullWidthMobile href="#gift-subscription-info">
              So funktioniert’s
            </Button>
          )}
        </div>
      </div>
      <div className={styles.right}>
        <Headline variant="h2" size="h3">
          {rightSideHeadline}
        </Headline>
        {!isBuyPage && <Text variant="p">Starte deine geschmacksvolle Reise mit den besten Kaffees der Welt:</Text>}
        <ul className="list">
          {listItems.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </div>
      {isBuyPage && (
        <img src="/assets/img/for-all@2x.png" width={200} height={175} alt="logo" className={styles.overlayImage} />
      )}
    </section>
  )
}
